import { SerializedComponent } from "../../components/SerializedApp";
import { ComponentBuilder } from "../components";
import { ActionDescription, ActionKind } from "../description";
import { ActionDescriptor } from "./action-descriptor";
import { BaseActionHandler } from "./base";

export class PopScreenHandler extends BaseActionHandler<ActionDescription> {
    public readonly kind = ActionKind.PopScreen;
    // FIXME: Proper icon
    public readonly iconName = "clipboard";

    public getDescriptor(): ActionDescriptor {
        return {
            name: "Go Back",
            properties: [],
        };
    }

    public makeAction(builder: ComponentBuilder): SerializedComponent | undefined {
        return builder.b.popAnyScreen;
    }

    // This action is not supported in Pages because the browser history might
    // do anything.  We support Close Modal there.
}
